import { SET_ALERT, REMOVE_ALERT } from "../actions/constants/auth";
// import { toast } from "react-toastify";

const initialState: any = [];

export default function alertReducer(state = initialState, action: any) {
  const { type, payload } = action;
  switch (type) {
    case SET_ALERT:
      // toast.success(JSON.stringify(payload));
      return [...state, payload];
    case REMOVE_ALERT:
      return state.filter((a: any) => a.id !== payload);
    default:
      return state;
  }
}
